module.exports = __webpack_public_path__ + "bronze.svg?583c4eec28ddb6d8d9fbdf172043313e";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bronze.svg
// module id = 110
// module chunks = 0